import { useState } from "react";
import { T } from "../themes";

export default function Field({ label, value, onChange, placeholder, type="text", textarea, onKeyDown, icon, append }) {
  const [focused, setFocused] = useState(false);
  const base = {
    width:"100%",background:T.surface,border:focused?`1.5px solid ${T.accent}`:T.border,
    boxShadow:focused?`0 0 0 3px ${T.accent}22`:"none",
    padding:icon?"12px 16px 12px 40px":"12px 16px",color:T.text,fontSize:14,
    fontFamily:T.fontSans,fontWeight:"500",outline:"none",boxSizing:"border-box",borderRadius:T.radiusSm,
    transition:"border-color 0.2s, box-shadow 0.2s",
  };
  return (
    <div style={{width:"100%",marginBottom:10}}>
      {label&&<label style={{color:T.textSub,fontSize:12,fontFamily:T.fontSans,letterSpacing:"0",display:"block",marginBottom:6,fontWeight:600}}>{label}</label>}
      <div style={{position:"relative"}}>
        {icon&&<span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",color:T.textDim,display:"flex"}}>{icon}</span>}
        {textarea
          ? <textarea value={value} onChange={onChange} placeholder={placeholder} rows={3} onFocus={()=>setFocused(true)} onBlur={()=>setFocused(false)} style={{...base,resize:"vertical",lineHeight:1.6,paddingTop:10,paddingBottom:10}}/>
          : <input value={value} onChange={onChange} placeholder={placeholder} type={type} onKeyDown={onKeyDown} onFocus={()=>setFocused(true)} onBlur={()=>setFocused(false)} style={base}/>
        }
        {append&&<span style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",cursor:"pointer",color:T.textDim,display:"flex"}}>{append}</span>}
      </div>
    </div>
  );
}
